import { FilterTypes, WMTableColumnShape } from '../WMTable/WMTable';
import { AppTableFilter, IAppTableRowData, ITableData } from '../model';
import { AppTableFilterOption, AppTableFiltersMetadata } from '../../../models/filters';

export type FiltersList = Record<string, AppTableFilter[]>;

export const generateFiltersList = (
    filtersMetadata: AppTableFiltersMetadata,
    columns: WMTableColumnShape[],
    defaultValues?: ITableData['filters']
) => {
    const filters = {};

    if (columns?.length && filtersMetadata) {
        columns
            .filter(column => column?.filterMetaData?.active)
            .forEach(column => {
                if (filtersMetadata[column.dataKey]) {
                    filters[column.dataKey] = filtersMetadata[column.dataKey].sort(column.sortFilterValues).map(
                        (option: AppTableFilterOption): AppTableFilter => ({
                            ...option,
                            checked: defaultValues?.[column.dataKey]?.some?.((defaultValue: string) => defaultValue === option.value) || false
                        })
                    );
                }
            });
    }

    return filters;
};

export const generateFiltersListFromData = (
    data: IAppTableRowData[] | undefined,
    columns: WMTableColumnShape[],
    defaultValues?: ITableData['filters']
) => {
    const filters = {};

    if (data?.length && columns?.length) {
        columns
            .filter(column => column?.filterMetaData?.active)
            .forEach(column => {
                if (column.filterMetaData?.type === FilterTypes.DATASOURCE && column.filterMetaData?.dataSources?.values) {
                    filters[column.dataKey!] = column.filterMetaData?.dataSources?.values.map(
                        ({ value, label }: { value: string; label: string }): AppTableFilter => ({
                            label,
                            value,
                            checked: defaultValues?.[column.dataKey]?.[0]
                                ? defaultValues?.[column.dataKey]?.[0] === value
                                : column.filterMetaData?.dataSources?.defaultValue === value
                        })
                    );
                } else {
                    filters[column.dataKey!] = Array.from(
                        new Set(
                            data
                                .filter(row => !row.fixedTop)
                                .map(row =>
                                    column?.filterMetaData?.extractFilterValues
                                        ? column?.filterMetaData?.extractFilterValues(row)
                                        : row[column.dataKey]
                                )
                                .flat()
                                .filter(Boolean)
                                .sort(column.sortFilterValues)
                        )
                    ).map(
                        (value: string): AppTableFilter => ({
                            label: value,
                            value: value,
                            checked: defaultValues?.[column.dataKey]?.includes?.(value) || false
                        })
                    );
                }
            });
    }

    return filters;
};
